import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ld-loading-spinner',
  imports: [MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {
  size = input<'small' | 'medium' | 'large'>('medium');

  fullPage = input<boolean>(false);

  message = input<string | null>(null);

  color = input<'primary' | 'accent' | 'white'>('accent');

  protected readonly diameter = computed(() => {
    switch (this.size()) {
      case 'small':
        return 16;
      case 'large':
        return 48;
      case 'medium':
      default:
        return 24;
    }
  });

  protected readonly colorClass = computed(() => {
    switch (this.color()) {
      case 'primary':
        return 'spinner-primary';
      case 'white':
        return 'spinner-white';
      case 'accent':
      default:
        return 'spinner-accent';
    }
  });
}
